<template>
  <v-dialog
    v-model="dialog"
    width="90%"
    style="z-index: 99999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.vehicle_log.title") + ((vehicle !== null) ? ': ' + vehicle.numericPlate : "")}}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-icon>mdi-calendar</v-icon>
        <v-select
          v-model="logDate"
          :items="$store.state.vehicleLog.logs"
          :label="$t('dialog.vehicle_log.log_date')"
          solo
          flat
          style="height: 50px; width: 0"
        >
          <template v-slot:selection="data">
            {{ formatDate(data.item) }}
          </template>
          <template v-slot:item="data">
            {{ formatDate(data.item) }}
          </template>

        </v-select>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-textarea
        solo
        flat
        style="width: 100%; height: 100%;"
        height="80vh"
        readonly
        hide-details
        no-resize
        :loading="$store.state.vehicleLog.fetching"
        :value="$store.state.vehicleLog.log" />
    </v-card>
  </v-dialog>
</template>

<script>

import { DateTime } from "luxon";

export default {
  name: "VehicleLogDialog",

  data() {
    return {
      dialog: false,
      logDate: null,
      vehicle: null
    };
  },

  methods: {
    open(vehicle) {

      this.logDate = null;
      this.dialog = true;
      this.vehicle = vehicle;

      this.$store.dispatch("vehicleLog/clear");
      this.$store.dispatch("vehicleLog/fetchLogs", { vehicleId: this.vehicle.vehicleId });
    },

    formatDate(dt) {
      return DateTime.fromFormat(dt, "yyyy-MM-dd").toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
    },
  },

  watch: {
    logDate: function() {
      this.$store.dispatch("vehicleLog/fetchLog", { vehicleId: this.vehicle.vehicleId, date: this.logDate });
    }
  }
};
</script>